import type mapboxgl from 'mapbox-gl'

// Non-reactive registry of live Mapbox instances used by split-screen tiles,
// keyed by mapId. Raw mapboxgl.Map objects must NEVER be stored in Vuex —
// Vue reactivity would deep-wrap the huge internal object graph and break
// Mapbox. Components react off the reactive `split` store state (tiles /
// syncEnabled) and read the raw instances from here on change.

const registry = new Map<string, mapboxgl.Map>()

export const registerInstance = (mapId: string, instance: mapboxgl.Map): void => {
  registry.set(mapId, instance)
}

export const unregisterInstance = (mapId: string): void => {
  registry.delete(mapId)
}

export const getInstance = (mapId: string): mapboxgl.Map | undefined => {
  return registry.get(mapId)
}

// Resolve an ordered list of mapIds to their live instances, skipping any that
// aren't currently mounted.
export const listInstances = (mapIds: string[]): mapboxgl.Map[] => {
  return mapIds.map(id => registry.get(id)).filter(Boolean) as mapboxgl.Map[]
}
